// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import * as styles from '../styles/WorkflowFlowchart.styles';
import g42Logo from '../assets/images/g42-logo.png';
import accellorLogo from '../assets/images/accellorLogoOriginal.svg';

const STEPS = [
  { id: 1, text: 'Self-declare your AI skill level', gradient: 'linear-gradient(180deg, #455391 0%, #8C9DEC 100%)' },
  {
    id: 2,
    text: '15-20 minutes interview with a skill assessment agent',
    gradient: 'linear-gradient(180deg, #35b7e1 0%, #a1e4e9 100%)'
  },
  {
    id: 3,
    text: 'Identify strengths, gaps and growth opportunities',
    gradient: 'linear-gradient(180deg, #2bb36f 0%, #77d9a7 100%)'
  },
  {
    id: 4,
    text: 'Recommend a training pathway for the user',
    gradient: 'linear-gradient(180deg, #ff3d52 0%, #ff6e80 100%)'
  }
];

export const WorkflowFlowchart = (): JSX.Element => {
  return (
    <div style={styles.root}>
      <div style={styles.logoWrap}>
        <img src={accellorLogo} alt="G42" style={styles.logoImage} />
      </div>
      <div style={styles.arrowDown} aria-hidden="true" />
      <h2 style={styles.mainTitle}>AI skill assessment and learning pathway agent</h2>
      <p style={styles.subtitle}>Your intelligent agent for AI skill assessment and training recommendation</p>
      <div style={styles.stepsRow}>
        {STEPS.map((step, index) => (
          <span key={step.id} style={{ display: 'flex', alignItems: 'center' }}>
            <div className="workflow-flow-step" style={{ ...styles.flowStep, background: step.gradient }}>
              <p style={styles.stepText}>{step.text}</p>
            </div>
            {index < STEPS.length - 1 && <div style={styles.triangle} aria-hidden="true" />}
          </span>
        ))}
      </div>
      <div style={styles.arrowDownBottom} aria-hidden="true" />
    </div>
  );
};
